import { EntityName } from 'record-it-time-common/EntityName';
import { User } from '../../../classes/entities/User/userTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';
export function useUserDeleteHandler(user) {
  return useEntityDeleteHandler(EntityName.User, user, _temp);
}
function _temp(u) {
  return u.email;
}